import { InlineAlert } from '@rbilabs/universal-components';
import { Icon } from '@rbilabs/universal-components';
import { StyleSheet, Text, View } from 'react-native';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { classifyPaymentMethods } from 'components/payment-method/utils';
import { t } from 'state/intl/translations';
import { useUIContext } from 'state/ui';
import { primitive } from 'styles/constants/primitives';

import { SelectorSelection, SelectorSelectionProps } from './selector-selection';

type SelectorPrepaidReloadProps = SelectorSelectionProps & { reloadAmount: number };

export function SelectorPrepaidReload({
  methods,
  selectedMethodId,
  reloadAmount,
  onChange,
}: SelectorPrepaidReloadProps) {
  const { formatCurrencyForUser } = useUIContext();
  const formattedReloadAmount = formatCurrencyForUser(reloadAmount);
  const { selectedMethod } = classifyPaymentMethods(methods, selectedMethodId ?? '');

  const reloadExplanationText = t('reloadExplanation.bk', { reloadAmount: formattedReloadAmount });
  const youWillBeChargedText = t('youWillBeCharged', { reloadAmount: formattedReloadAmount });
  const reloadMessage = `${reloadExplanationText} ${youWillBeChargedText}`;

  return (
    <View style={styles.container}>
      <InlineAlert message={reloadMessage} status="info" backgroundColor="#FFCFAD" />
      <View style={styles.labelContainer}>
        <Text style={styles.instructionText}>
          {t('loadWith')}
          {':'}
        </Text>
        <View style={styles.divider} />
      </View>

      {methods.length > 0 ? (
        <SelectorSelection
          methods={methods}
          selectedMethodId={selectedMethod?.accountIdentifier ?? undefined}
          onChange={onChange}
        />
      ) : (
        <ActionButton
          testID="add-reload-payment-btn"
          width="100%"
          height="$10"
          marginY="$6"
          _text={{ fontSize: 'sm' }}
          variant={ActionButtonVariants.OUTLINE}
          leftIcon={<Icon variant="add" aria-hidden />}
          onPress={onChange}
        >
          {t('addPayment')}
        </ActionButton>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginVertical: primitive.spacing.$4,
  },
  instructionText: {
    fontFamily: primitive.fontFamily.$headers,
    color: primitive.bk.$bbqBrown,
    fontSize: 18,
    fontWeight: 'normal',
    marginTop: primitive.spacing.$3,
    marginBottom: primitive.spacing.$2,
  },
  divider: {
    borderBottomWidth: 1,
    borderBottomColor: primitive.$blackOpacity10,
    marginBottom: primitive.spacing.$4,
  },
  labelContainer: {
    marginTop: primitive.spacing.$3,
  },
});
